export default function Icon({ name, size = 16, color = "currentColor", strokeWidth = 1.6 }) {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };
  switch (name) {
    case "gem":
      return (
        <svg {...props}>
          <path d="M6 3h12l3 5-9 13L3 8z" fill="#4B7B8A" stroke="#2F5562" />
          <path d="M3 8h18M9 3l3 5 3-5M9 8l3 13 3-13" stroke="#2F5562" strokeWidth="1.2" />
        </svg>
      );
    case "heart":
      return (
        <svg {...props}>
          <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" fill="#C23B3B" stroke="#8A2A2A" />
        </svg>
      );
    case "flame":
      return (
        <svg {...props}>
          <path d="M12 3c1 3 4 4 4 8a4 4 0 1 1-8 0c0-2 1-3 2-4 0 1 1 2 2 2 0-2-1-4 0-6z" fill="#D97757" stroke="#8A3B1E" />
        </svg>
      );
    case "bolt":
      return (
        <svg {...props}>
          <path d="M13 3 4 14h7l-1 7 9-11h-7l1-7z" fill="#C8953B" stroke="#7A5A1F" />
        </svg>
      );
    case "check":
      return <svg {...props}><path d="M4 12l5 5L20 6" /></svg>;
    case "x":
      return <svg {...props}><path d="M6 6l12 12M18 6L6 18" /></svg>;
    case "arrow-right":
      return <svg {...props}><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
    case "arrow-left":
      return <svg {...props}><path d="M19 12H5M11 6l-6 6 6 6" /></svg>;
    case "sparkle":
      return (
        <svg {...props}>
          <path d="M12 3v6M12 15v6M3 12h6M15 12h6M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3" />
        </svg>
      );
    case "search":
      return <svg {...props}><circle cx="11" cy="11" r="6" /><path d="M20 20l-4-4" /></svg>;
    case "book":
      return <svg {...props}><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M4 5v16" /></svg>;
    case "target":
      return <svg {...props}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4" /><circle cx="12" cy="12" r="1" fill={color} /></svg>;
    case "trophy":
      return (
        <svg {...props}>
          <path d="M7 4h10v5a5 5 0 0 1-10 0z" fill="#C8953B" stroke="#7A5A1F" />
          <path d="M7 6H4a3 3 0 0 0 3 3M17 6h3a3 3 0 0 1-3 3" />
          <path d="M9 14v2h6v-2M8 20h8" />
        </svg>
      );
    case "lock":
      return <svg {...props}><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 1 1 8 0v3" /></svg>;
    case "play":
      return <svg {...props}><path d="M7 4v16l14-8z" fill={color} /></svg>;
    case "close":
      return <svg {...props}><path d="M6 6l12 12M18 6L6 18" /></svg>;
    case "medal":
      return (
        <svg {...props}>
          <circle cx="12" cy="14" r="6" fill="#C8953B" stroke="#7A5A1F" />
          <path d="M8 8l-3-5h6l3 5M16 8l3-5h-6l-3 5" stroke="#8A3B1E" />
          <circle cx="12" cy="14" r="2.5" fill="#F1E3C3" stroke="#7A5A1F" strokeWidth="1" />
        </svg>
      );
    case "skull":
      return <svg {...props}><circle cx="12" cy="11" r="7" /><circle cx="9" cy="11" r="1" fill={color} /><circle cx="15" cy="11" r="1" fill={color} /><path d="M9 18h6M10 18v2M14 18v2" /></svg>;
    case "logout":
      return <svg {...props}><path d="M15 12H3M7 8l-4 4 4 4M9 4h10v16H9" /></svg>;
    default:
      return null;
  }
}
